import { locale } from '../../utils/i18n';
import { staticPath } from '../../utils/common';

const NotFound = () => (
  <div className={`ptm-no-bank ptm-pos-a`}>
    <img
      className={`ptm-margin0 ptm-icon-bank_results_not_found`}
      src={`${staticPath()}/assets/images/not_found.png`}
    />
    <p className={`ptm-no-result ptm-body-color`}>{locale('nb.no.result.found')}</p>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./components/nb/notFound.js